import React, { Component } from 'react';
import moment from 'moment';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services/index.js';
import EventTokenList from '../../event-token-list/event-token-list.js';
class DatePickerEventsPanel extends Component {
    constructor() {
        super(...arguments);
        this.formatDateDisplay = (date, todayExp) => {
            if (moment.utc().isSame(date, 'date')) {
                return React.createElement("span", null,
                    date.format('LL'),
                    " - ",
                    MessageService.translate(todayExp));
            }
            return React.createElement("span", null,
                date.format('LL'),
                " - ",
                date.format('dddd'));
        };
    }
    getEvents() {
        const { data, date } = this.props;
        if (!Array.isArray(data)) {
            return [];
        }
        const day = data.find(day => date.isSame(day.date, 'date'));
        return day?.events ?? [];
    }
    render() {
        const { date, todayExpression = 'tws.datepicker.today', noAppointmentsExpression = 'tws.datepicker.no-appointments', } = this.props;
        const events = this.getEvents();
        return (React.createElement("div", { className: "c-date-picker__events" },
            React.createElement("span", { className: "c-date-picker__events-date" }, this.formatDateDisplay(date, todayExpression)),
            events.length
                ? React.createElement(EventTokenList, { data: events })
                : React.createElement("span", { className: "c-date-picker__no-events" }, MessageService.translate(noAppointmentsExpression))));
    }
}
export { DatePickerEventsPanel, };
//# sourceMappingURL=date-picker-events-panel.js.map